import {
  Box,
  PDF_BORDER,
  ReportPage,
  ReportTable,
  ReportTableTextCell,
  Text,
} from '@/components';
import { ReportBatchTargetLabelModifier } from '@/features/mold/models';
import type { OrganizingTableFormat1Props } from '@/features/mold/utils/pdf/pdf-components-props';
import { useLocaledAmount } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const OrganizingTableFormat1: FC<OrganizingTableFormat1Props> = ({
  header,
  body,
  footer,
  organizationNames,
  dateByCreated,
  paperSize,
}) => {
  const { unit } = useLocaledAmount();
  const { t } = useTranslation();

  return (
    <ReportPage
      title={{
        text: ReportBatchTargetLabelModifier['rs-report1'],
        variant: 'footnote',
      }}
      layout={{
        paperSize,
        orientation: 'landscape',
      }}
      headerStyle={{ gap: 16 }}
      caption={{
        unit,
        item: <Text weight="bold" variant="small" text={organizationNames} />,
      }}
      dateByCreated={dateByCreated}
    >
      <>
        <ReportTable
          header={header}
          data={body}
          footer={footer}
          defaultBorderStyle={PDF_BORDER.THIN}
          borderColor="secondary"
          tableWidth="100%"
        />
        <Box marginTop={4}>
          <ReportTableTextCell
            textStyle={{ lineHeight: 1.3, paddingBottom: 0 }}
            text={t('report-organizing-table-format1-footnote1')}
          />
          <ReportTableTextCell
            textStyle={{ lineHeight: 1.3, paddingTop: 0 }}
            text={t('report-organizing-table-format1-footnote2')}
          />
        </Box>
      </>
    </ReportPage>
  );
};
